import { render } from "./Listar.vue?vue&type=template&id=41f91742"
import script from "./Listar.vue?vue&type=script&lang=js"
export * from "./Listar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\front\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__